!<template>
<div>
    <div class="modal fade" role="dialog" id="Modal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Contactos</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="ibox">
                                <table class="table table-striped table-bordered w-100">
                                    <thead>
                                        <tr>
                                            <th>
                                                Numero
                                            </th>
                                            <th>
                                                Nombre
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(data, k) in dt.datos" :key="k">
                                            <td>
                                                {{data.numero}}
                                            </td>
                                            <td>
                                                {{data.nombre}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>


export default {
    props: ['interacciones'],
    data() {
        return {
            dt: {
                id: 'dt2',
                columnas: [
                    { nombre: 'Numero', nombre_variable: 'numero' },
                    { nombre: 'Nombre', nombre_variable: 'nombre' },
                ],
                datos: []
            }
        }
    },
    mounted() {

    },
    methods: {
        show() {
            $('#Modal').modal('show')
        },
        hide() {
            console.log("entre");
            this.dt.datos = [];
            $('#Modal').modal('hide')
        },
    },
    watch: {
        interacciones() {
            // console.log(this.interacciones);
            this.dt.datos = [];
            this.$forceUpdate();
            this.dt.datos = this.interacciones.map(element => {
                return {
                    numero: element.interaccion.direccion_mensaje == "Entrada" ? element.interaccion.emisor : element.interaccion.receptor,
                    nombre: element.interaccion.data_respuesta ? JSON.parse(element.interaccion.data_respuesta).nombre : ""
                }
            })
            console.log(this.dt.datos);
            this.$forceUpdate();

        }
    }
}
</script>
